<template>

<div v-if="isGranted([permissions.ACTIVITY_INTEGRITY_VIEW, permissions.ACTIVITY_INTEGRITY_VIEW_OWN], activity)"
     qid="integrity-check-section"
     id="update_integrity_check"
>
  <div class="card integrity_check">
    <div class="card-header" :class="{'pr-0 pl-0': showOnTask}">
      <div class="float-right">
        <ValidationForm
            :object="activity"
            scope="validate_integrity_check"
            type="integrity_check"
            :checklist="validationOptions"
            @validationModalClose="handleValidationModalClose"
            v-if="getClient.gdprAdvancedModule && !showOnTask && isGranted([permissions.ACTIVITY_INTEGRITY_VALIDATE, permissions.ACTIVITY_INTEGRITY_VALIDATE_OWN], activity)"
        ></ValidationForm>

        <span v-if="isGranted([permissions.ACTIVITY_INTEGRITY_EDIT, permissions.ACTIVITY_INTEGRITY_EDIT_OWN], activity)"
              class="float-right btn btn-success"
              qid="integrity-edit-button"
              @click="showFormFunction"
        >
            <font-awesome-icon icon="pen"/> {{ $t('system.edit') }}
          </span>

      </div>
      <div class="float-left">

        <h5 class="mb-2" qid="integrity-check-table-title" v-if="!showOnTask">
          {{ $t('activities.integrity_check.title') }}
        </h5>

        <span v-if="!showOnTask">
          <span class="cursor-pointer task-label-open mr-2"
                v-if="getTask('update_integrity_check')"
          >
            <UpdateSingleTaskModal
                :task="getTask('update_integrity_check')"
                @reloadContent="reloadContent"
                :editIcon="true"
            ></UpdateSingleTaskModal>
          </span>
          <span v-if="getGuide('update_integrity_check')">
            <GuideButton :guide="getGuide('update_integrity_check')"></GuideButton>
          </span>
        </span>
      </div>

      <div class="validation-info" qid="view-integrity-check-validation" v-if="validation && !showOnTask">
        <span v-if="validation && validation.validation === 1">
          <font-awesome-icon icon="check-circle" class="icon-success"/>
          {{ $t('system.approved') }}
        </span>
        <span v-if="validation && validation.validation === 0">
          <font-awesome-icon icon="times-circle" class="icon-danger"/>
          {{ $t('system.rejected') }}
        </span>
        <span v-if="validation" class="text-muted font-italic">
          {{ $t('system.by') }}
          <span v-if="validation.created_by" qid="view-intregrity-check-validation-by">
            {{ validation.created_by.name }}
          </span>
        </span>
        <span v-if="validation" class="text-muted font-italic">
          {{ $t('system.on') }}
          <span v-if="validation.created_at" qid="view-integrity-check-validation-date">
            {{ validation.created_at | formatDate }}
          </span>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card-body">

          <div class="mw-500" v-if="showForm">
            <label for="">{{ $t('activities.integrity_check.integrity_check_label') }}</label>
            <b-form-radio-group
              v-model="integrity_check"
              :options="radioOptions"
              qid="integrity-form-radio"
              class="mt-1"
            ></b-form-radio-group>
            <br>
            <label for="">{{ $t('activities.integrity_check.description_label') }}</label>
            <b-form-textarea
              qid="integrity-form-description"
              v-model="description"
              rows="6"
              :placeholder="$t('activities.integrity_check.description_placeholder')"
            ></b-form-textarea>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="cancelForm"
                        qid="integrity-edit-cancel-button"
              >
                {{ $t('activities.integrity_check.cancel') }}
              </b-button>
              <b-button class="mt-3 ml-3"
                        variant="success"
                        @click="formSubmit"
                        qid="integrity-edit-submit-button"
              >
                {{ $t('activities.integrity_check.submit') }}
              </b-button>
            </div>
          </div>

          <div v-if="!showForm">
            <div v-if="activity.gdpr">
              <label for="">{{ $t('activities.integrity_check.integrity_check_label') }}</label>
              <p class="section-container">
                <span v-if="activity.gdpr.integrity_check === 0">
                  <font-awesome-icon icon="times" class="mr-2 text-danger"/>
                  {{ $t('system.no') }}
                </span>
                <span v-if="activity.gdpr.integrity_check === 1">
                  <font-awesome-icon icon="check" class="mr-2 text-success"/>
                  {{ $t('system.yes') }}
                </span>
              </p>
              <br>
              <label for="">{{ $t('activities.integrity_check.description_label') }}</label>
              <p class="section-container">
                <span v-if="activity.gdpr.integrity_description" class="text-formatted">{{activity.gdpr.integrity_description}}</span>
                <span v-if="!activity.gdpr.integrity_description" class="text-muted">
                  {{ $t('system.missing_input') }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="text-center card-body" v-if="!showOnTask">
          <span class="cursor-pointer"
                @click="validationShow = !validationShow"
                qid="expand-integrity-validations"
          >
            <span class="mr-2">
              {{ $t('system.view_validation_log') }}
            </span>
            <font-awesome-icon icon="chevron-down" v-if="!validationShow"/>
            <font-awesome-icon icon="chevron-up" v-if="validationShow"/>
          </span>
        </div>
        <div v-show="validationShow && !showOnTask" class="card-body">
          <ValidationList
              :object="activity"
              type="integrity_check"
              :reloadList="updateValidationList"
              @validationListUpdated="setValidation"
          ></ValidationList>
        </div>
      </div>

    </div>
  </div>
</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'IntegrityCheck',
    data: function() {
      return {
        form: {

        },
        selectedIC: [],
        newIC: [],
        description: '',
        integrity_check: '',
        error: '',
        loadingItems: false,
        validationShow: false,
        updateValidationList: false,
        showForm: false,
        icItems: [],
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        validation: undefined,
        activity: {},
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object
      },
      showOnTask: {},
      task: {}
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    components: {
      ValidationForm,
      ValidationList,
      UpdateSingleTaskModal,
      GuideButton
    },
    watch: {
      object: function (value) {
        this.activity = value
        this.setDefaultForm(value)
        this.loadTasks('update_integrity_check');
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.activity.id && this.$store.state.updatedObject.who_am_i == this.activity.who_am_i) {
              this.activity = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_integrity_check')
        }
      },
    },
    methods: {
      addIC(newIC) {
        const tag = {
          name: newIC,
          translatable: newIC,
          name_translated: newIC
        }
        this.selectedIC.push(tag)
        this.newIC.push(tag)
      },
      reloadContent() {
        this.loadActivity()
        this.loadTasks('update_integrity_check')
      },
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.activity.who_am_i,
              model_id: this.activity.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Activity' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Activity',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      setValidation(object) {
        this.validation = object
      },
      formSubmit(evt) {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedIC) {
          this.form.integrity_controls = [];
          if (this.selectedIC && this.selectedIC.length) {
            for (var i = 0; i < this.selectedIC.length; i++) {
              this.form.integrity_controls.push(this.selectedIC[i].name);
            }
          }
        } else {
          this.form.integrity_controls = null
        }
        this.form.integrity_check = this.integrity_check;
        this.form.integrity_description = this.description;

        piincHttp.put('activities/' + this.activity.slug, this.form).then(function(response) {
          self.activity = response.data
          self.$emit('updated');
          self.loadTasks('update_integrity_check');
          self.showForm = false;
          self.$toastr('success', self.$t('activities.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      handleValidationModalClose() {
        this.loadActivity();
        this.updateValidationList = true
      },
      cancelForm() {
        this.showForm = false
      },
      showFormFunction() {
        this.integrity_check = this.activity.gdpr.integrity_check
        this.description = this.activity.gdpr.integrity_description
        this.selectedIC = this.activity.integrity_controls == null ? [] : this.activity.integrity_controls
        this.newIC = [];
        this.showForm = true
      },
      loadActivity() {
        let self = this;
        piincHttp.get('activities/' + this.activity.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.activity = response.data;
        }, function() {});
      },
      setDefaultForm(object) {
        if (object.gdpr.confidentiality_impact) {
          this.selectedIC = _.find(this.icItems, function(item) {
            return item.value === object.gdpr.confidentiality_impact;
          });
        }
        this.integrity_check = this.activity.gdpr.integrity_check;
        this.description = this.activity.gdpr.confidentiality_impact_description;
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      loadIC(query) {
        let self = this;
        piincHttp.get('integrity-controls', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.icItems = response.data.items
          if (self.icItems && !self.icItems.length && !query) {
            self.icItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
          for (var i = 0; i < self.newIC.length; i++) {
            self.icItems.push(self.newIC[i]);
          }
        }, function() {});
      },

    },
    created () {
      this.activity = this.object
      this.validationOptions = this.activity.integrityValidationOptions;
      this.setDefaultForm(this.activity)
      if (this.getClient && this.getClient.slug) {
        this.loadIC();
      }
      if (this.activity && this.activity.slug) {
        this.loadTasks('update_integrity_check');
      }
      this.loadGuides('update_integrity_check');

    }
  }
</script>
